import React from 'react'
import { ProgressBar, Cell, Grid } from 'react-mdl'
import SearchBar from '../../components/SearchBar'
import ImageItem from './ImageItem'
import Button from '../../components/Button'

const LibraryScreen = ({
  searchTerm,
  libraryImages,
  searchingLibrary,
  imageIds,
  handleSearch,
  handleSearchChange,
  handleImageSelect,
  images,
  goToPanel,
}) => (
  <div>
    <h3>Choose Images</h3>
    <p>Use the search bar to find the most appropriate image.</p>
    <SearchBar
      onSearch={handleSearch}
      onSearchChange={handleSearchChange}
      searchTerm={searchTerm}
      searching={searchingLibrary}
      label="Search..."
    />
    <div>
      {searchingLibrary ? (
        <ProgressBar indeterminate />
      ) : !libraryImages ? (
        <p>Enter search term above.</p>
      ) : libraryImages.length === 0 ? (
        <p>No results.</p>
      ) : (
        <Grid style={{ overflowY: 'auto', maxHeight: '50vh' }}>
          {libraryImages.map((image, i) => (
            <Cell key={i} col={6} onClick={handleImageSelect(image)}>
              <ImageItem {...image} selected={imageIds.includes(image._id)} />
            </Cell>
          ))}
        </Grid>
      )}
    </div>
    <Cell col={12} style={{ display: 'flex' }}>
      <Button
        style={{ marginLeft: 'auto' }}
        disabled={!images}
        onClick={goToPanel('edit-images')}>
        Continue
      </Button>
    </Cell>
  </div>
)

export default LibraryScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/LibraryScreen.js